import { Modal, Button, Input, Table, Menu, Dropdown } from 'antd';
import React, { useEffect, useState } from 'react';
import { GestionPaieService } from '../../Services/GestionPaieService';
import { DownOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
const PassationModal = ({ visible, onClose, debut, fin }) => {
    const gestionPaieService = new GestionPaieService();
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    useEffect(() => {
      if (visible && debut && fin) {
        fetchData(debut, fin);
      }
    }, [visible, debut, fin]);
    const fetchData = async (debut, fin) => {
        const datedeb = debut;
        const datefin = fin;
        try {
          const response = await gestionPaieService.addPassation(datedeb, datefin);
          setData(response);
          setOriginalData(response); // Mettre à jour les données originales
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
        }
      };
    const handleSearch = (value) => {
        setSearchText(value);
        if (value === '') {
          setData(originalData); // Restaurer les données originales lorsque la recherche est effacée
        } else {
          const filtered = originalData.filter((item) =>
            Object.values(item).some(
              (val) =>
                val && val.toString().toLowerCase().includes(value.toLowerCase())
            )
          );
          setData(filtered);
        }
      };
      

  const columns = [
    { title: 'C.JL', dataIndex: 'codej', key: 'codejj' },
    { title: 'D. Compta', dataIndex: 'datecompta', key: 'datecompta' },
    { title: 'Mois trait.', dataIndex: 'datetrait', key: 'datetrait' },
    { title: 'N° pièce', dataIndex: 'numpiece', key: 'numpiece' },
    { title: 'N° Chèque', dataIndex: 'numcheque', key: 'numcheque' },
    { title: 'N° F. IPM', dataIndex: 'numIPM', key: 'numIPM' },
    { title: 'Cpte. Gen.', dataIndex: 'comptegen', key: 'comptegen' },
    { title: 'Cpte. Tiers', dataIndex: 'comptetiers', key: 'comptetiers' },
    { title: 'Libellé', dataIndex: 'libelle', key: 'libelle' },
    {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              paddingRight: 5,
            }}
          >
            Débit
          </div>
        ),
        dataIndex: "debit",
        key: "debit",
        align: "right",
        render: (text) => (
          <div style={{ paddingRight: 10 }}> {parseFloat(text)}</div>
        ),
      },
      {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              paddingRight: 10,
            }}
          >
            Crédit
          </div>
        ),
        dataIndex: "credit",
        key: "credit",
        align: "right",
        render: (text) => (
          <div style={{ paddingRight: 10 }}>
            {parseFloat(text)}
          </div>
        ),
      },
  ];


  const handleValider = async () => {
    try {
        const payload = {
            comptas : [...data],
            factures:null
        }
      await gestionPaieService.addcomptabilis(payload); // Appeler la méthode pour valider les données
      // Afficher une notification ou effectuer d'autres actions en cas de succès
      console.log('Données validées avec succès !');
      onClose();
    } catch (error) {
      console.error('Erreur lors de la validation des données :', error);
      // Gérer l'erreur ici si nécessaire
    }
  };

  const handlePrint = () => {
   
    gestionPaieService.printPassationModal();
    
  };
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data); // Convertir les données en feuille Excel
    const wb = XLSX.utils.book_new(); // Créer un nouveau classeur Excel
    XLSX.utils.book_append_sheet(wb, ws, 'Passation Comptable'); // Ajouter la feuille de données au classeur
  
    // Sauvegarder le fichier Excel
    XLSX.writeFile(wb, 'Aperçu écriture au journal.xlsx');
  };
  const gestionMenu = (
    <Menu>
      <Menu.Item  key="1" onClick={exportToExcel}  >
        Excel
      </Menu.Item>
      <Menu.Item  key="2"onClick={handlePrint} >
        PDF
      </Menu.Item>
      
    </Menu>
  );
  return (
    <Modal
    style={{top:20}}
      open={visible}
      maskClosable={false}
      width={1100}
      title="Aperçu écriture au journal"
      onCancel={onClose}
      footer={[
        <>
        <Dropdown overlay={gestionMenu} trigger={["click"]}>
        <Button className="buttonExport">
          Export
        <DownOutlined />
        </Button>
      </Dropdown>
        <Button key="cancel" className="buttonClose" onClick={onClose}>Annuler</Button>,
        <Button key="validate" className="Buttonvalid" onClick={handleValider}>Valider</Button>,
        </>
      ]}
    >
        <div >
      <Input.Search
        placeholder="Recherche"
        allowClear
        onChange={(e) => handleSearch(e.target.value)}
        onPressEnter={(e) => handleSearch(e.target.value)}
        
        style={{ marginBottom: 10, width:"50%" }}
      />
      </div>
      <Table
        dataSource={data}
        columns={columns}
        
        scroll={{
            x: true,
          }}
          showSorterTooltip={false}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header1-table"
          bordered
          pagination={{
            pageSize: 5, 
          }}
      />
    </Modal>
  );
};

export default PassationModal;
